import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { useUserDataContext } from '../../../../wiring/user-provider';
import Styles from './selectAutoCompleteStyles';
import StateList from './state-list';

import useI18n from '../../../../utils/use-i18n';
import slugify from '../../../../utils/slugify';
import ContentEnglish from './i18n/en';
import ContentSpanish from './i18n/es';

const content = {
    en: ContentEnglish,
    es: ContentSpanish,
};

const AutoComplete = ({ classes }) => {
    const { selectedState } = useUserDataContext();
    const history = useHistory();
    const [selectedValue, setSelectedValue] = useState(null);
    const handleChange = (event, newValue) => {
        if (newValue) history.push(`/state/${slugify(newValue)}`);
    };

    useEffect(() => {
        setSelectedValue(selectedState);
    }, [selectedState]);

    const Label = useI18n('label', content);

    return (
        <>
            <div className="offscreen" id="autocompletelabel">
                {useI18n('label_screen_reader', content)}
            </div>
            <Autocomplete
                options={StateList}
                value={selectedValue}
                id="stateSelectDesktop"
                // disablePortal <- enhances accessiblity, breaks presentation (https://material-ui.com/components/autocomplete/)
                // debug
                autoSelect
                onChange={(event, newValue) => handleChange(event, newValue)}
                disableClearable
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={Label}
                        InputLabelProps={{
                            classes: {
                                shrink: classes.labelShrink,
                                root: classes.input,
                                formControl: classes.formControl,
                            },
                        }}
                        InputProps={{
                            ...params.InputProps,
                            classes: {
                                underline: classes.underline,
                            },
                        }}
                    />
                )}
                classes={{
                    root: classes.root,
                    inputRoot: classes.inputRoot,
                    input: classes.input,
                    popupIndicator: classes.popupIndicator,
                    popupIndicatorOpen: classes.popupIndicatorOpen,
                    option: classes.option,
                }}
            />
        </>
    );
};

AutoComplete.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(Styles)(AutoComplete);
